import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Category } from '../../helpers/types';
import ActionsMenu from '../../sharedComponents/ActionsMenu';

export const MobileRowMainContent = ({ data }: { data: Category }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          marginRight: 1,
        }}
      >
        <Typography variant="body1" fontWeight={600}>
          {data.name || ''}
        </Typography>
        <Typography variant="body1">
          {data.isWet
            ? t('screens.products.sidekick.import.productsTable.wet')
            : t('screens.products.sidekick.import.productsTable.dry')}
        </Typography>
      </Box>
      <ActionsMenu objectId={data.id} />
    </Box>
  );
};

export const MobileRowExpandableContent = ({ data }: { data: Category }) => null;
